<template>
    <div class="container weeducAdminCourse page-card">
        <!-- Header do Curso -->
        <div class="titleContainer pb-3">
            <div
                class="title-banner-course"
                data-aos="fade-right"
                data-aos-duration="1500"
            >
                <img :src="currentCollections.imageFinalPath" alt="Weflix" />
                <span
                    class="status-flag"
                    :class="
                        currentCollections.status == 1 ? 'active' : 'inactive'
                    "
                >
                    {{ currentCollections.status == 1 ? 'Ativo' : 'Inativo' }}
                </span>
            </div>
            <div
                class="title-content"
                data-aos="fade-right"
                data-aos-duration="1500"
            >
                <small>Id: {{ currentCollections.id }}</small>
                <h3>{{ currentCollections.comercialName }}</h3>
                <span v-html="currentCollections.shortDescription"></span>
            </div>
            <!-- <div
                class="title-actions"
                data-aos="fade-down"
                data-aos-duration="1500"
            >
                <v-btn
                    :icon="$vuetify.display.xs"
                    class="editCollections"
                    variant="elevated"
                    color="primary"
                    rounded="2"
                    @click="editarCurso"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-square-edit-outline</v-icon>
                    </template>
                    <template v-else>
                        <v-icon start>mdi-square-edit-outline</v-icon>
                        Editar
                    </template>
                </v-btn>
            </div> -->
            <div
                class="infoCollectionStats"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <div class="statsRow clickable-stats" @click="goToMatriculasReport">
                    <fa icon="fa-users" />
                    <p class="text d-none d-md-block">Total de Matrículas:</p>
                    <strong class="text">{{ infoCount.totalEnrols }}</strong>
                </div>
                <div class="statsRow">
                    <fa icon="fa-dollar-sign" />
                    <p class="text d-none d-md-block">Faturamento:</p>
                    <strong class="text">
                        {{
                            infoCount.invoicing
                                ? infoCount.invoicing.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                  })
                                : 'N/A'
                        }}
                    </strong>
                </div>
            </div>
            <div class="actionsCourse">
                <v-btn
                    :icon="$vuetify.display.xs"
                    class="newEnrol"
                    variant="elevated"
                    color="primary"
                    rounded="2"
                        v-tooltip="'Matricular Aluno'"
                        @click="openDialogMatricularAluno"
                    >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-cart-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon start>mdi-cart-plus</v-icon>
                       Nova Matrícula
                    </template>
                    </v-btn>

                <v-btn
                :icon="$vuetify.display.xs"
                class="editCollections"
                variant="elevated"
                color="primary"
                rounded="2"
                @click="editarCurso"
            >
                <template v-if="$vuetify.display.xs">
                    <v-icon>mdi-square-edit-outline</v-icon>
                </template>
                <template v-else>
                    <v-icon start>mdi-square-edit-outline</v-icon>
                    Editar Curso
                </template>
            </v-btn>
            </div>
        </div>

        <!-- Estatísticas de Vídeos -->
        <div class="infoCollectionVideos row">
            <div
                class="videosInfoCollection col-12 col-lg-6 py-2"
                data-aos="fade-right"
                data-aos-duration="1500"
            >
                <p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path
                            fill="#250891"
                            d="M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                        />
                    </svg>
                    <span class="info-text"
                        >{{ infoCount.timeTotal }}
                        <span class="info-text-min">min</span></span
                    >
                </p>
                <p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path
                            fill="#250891"
                            d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7l0-147.5L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"
                        />
                    </svg>
                    <span class="info-text"
                        >{{ infoCount.totalVideos }}
                        <span class="info-text-min">videos</span></span
                    >
                </p>
                <p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style="width: 11px"
                        viewBox="0 0 384 512"
                    >
                        <path
                            fill="#24385c"
                            d="M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"
                        />
                    </svg>
                    <span class="info-text"
                        >{{ infoCount.totalDocuments }}
                        <span class="info-text-min">materiais</span></span
                    >
                </p>
                <p>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path
                            fill="#160266"
                            d="M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                        />
                    </svg>
                    <span class="info-text"
                        >{{ infoCount.totalQuizes }}
                        <span class="info-text-min">questionários</span></span
                    >
                </p>
            </div>
            <div
                class="col-12 col-lg-6 py-2 d-flex justify-content-end align-items-center"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
             
                    <v-text-field
                        type="text"
                        v-model="searchTerm"
                        placeholder="Pesquisar módulos..."
                        variant="outlined"
                        hide-details
                        density="compact"
                        class="inputd mr-2 flex-grow-1"
                        append-inner-icon="mdi-magnify"
                        clearable
                    />

                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="2"
                    :height="$vuetify.display.xs ? '40' : '45'"
                    :icon="$vuetify.display.xs"
                    class="no-uppercase"
                    @click="openNewModuleDialog"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon start>mdi-plus</v-icon>
                        Novo módulo
                    </template>
                </v-btn>
            </div>
        </div>

        <!-- Lista de Módulos e Aulas -->
        <draggable
            :list="filteredModules"
            :disabled="false"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="onDragEnd"
            handle=".drag-handle"
            data-aos="fade-up"
            data-aos-duration="1500"
        >
            <template #item="{ element }">
                <div class="table-modules">
                    <div
                        class="title-table"
                        @click="element.isOpen = !element.isOpen"
                    >
                        <div class="module-header">
                            <div class="drag-handle">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 448 512"
                                    fill="#250891"
                                >
                                    <path
                                        d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zm0 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                                    />
                                </svg>
                            </div>
                            {{ element.title }}
                            <span class="lesson-count"
                                >({{ element.lessons.length }} atividades)</span
                            >
                        </div>
                        <div class="module-actions">
                            <div
                                @click.stop="
                                    openModalEditModule(
                                        element.id,
                                        element.title
                                    )
                                "
                                class="btn-action"
                            >
                                <fa icon="fa fa-pencil" />
                            </div>
                            <div class="dropdown" @click.stop>
                                <button
                                    class="btn-action dropdown-toggle"
                                    @click.stop="toggleDropdown(element)"
                                >
                                    <fa icon="fa-solid fa-plus" />
                                    <span class="info-text-min"
                                        >Nova Atividade</span
                                    >
                                </button>
                                <div
                                    class="dropdown-content"
                                    v-show="element.showDropdown"
                                    v-click-outside="
                                        () => (element.showDropdown = false)
                                    "
                                    :id="element.id"
                                >
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/novo-video"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(3)" />
                                            Vídeo
                                        </router-link>
                                    </div>
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/novo-arquivo"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(4)" />
                                            Arquivo PDF
                                        </router-link>
                                    </div>
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/quiz"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(5)" />
                                            Questionário
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-action">
                                <fa
                                    :icon="
                                        element.isOpen
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    "
                                />
                            </div>
                        </div>
                    </div>

                    <draggable
                        v-show="element.isOpen"
                        :list="element.lessons"
                        :disabled="false"
                        ghost-class="ghost"
                        @start="draggingLesson = true"
                        @end="onDragEndLesson(element.id)"
                        handle=".drag-handle"
                        class="list-lessons"
                        item-key="id"
                    >
                        <template #item="{ element: lesson }">
                            <div class="lesson-row" :key="lesson.id">
                                <div class="lesson-content">
                                    <div class="drag-handle">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 448 512"
                                            fill="#250891"
                                        >
                                            <path
                                                d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zm0 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                                            />
                                        </svg>
                                    </div>
                                    <span style="color: #d4d4d4">|</span>
                                    <span class="lesson-icon">
                                        <fa
                                            :icon="getLessonIcon(lesson.type)"
                                        />
                                    </span>
                                    <span> </span>
                                    {{ lesson.title }}
                                </div>
                                <div
                                    @click="openModalEdit(lesson)"
                                    class="btn-action"
                                >
                                    <fa icon="fa fa-pencil" />
                                </div>
                                <div
                                    class="btn-action"
                                    @click="openModalDelete(lesson)"
                                >
                                    <fa icon="fa fa-trash" />
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </template>
        </draggable>

        <!-- Mensagem caso não haja vídeos -->
        <div class="noVideos" v-if="videos?.length === 0 && hasReady">
            <p>
                Envie novos videos para esta coleção clicando aqui
                <fa
                    icon="fa-plus"
                    @click="() => this.$router.push(`/admin/novo-video`)"
                />
            </p>
        </div>

        <!-- Diálogos e Loaders -->
        <div class="pa-4 text-center">
            <v-dialog v-model="deleteItem" max-width="320" persistent>
                <v-card>
                    <v-card-title class="headline">Atenção</v-card-title>
                    <v-card-text>
                        Deseja realmente excluir o vídeo {{ nameItem }}?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="cancel" text @click="closeDialog"
                            >Não</v-btn
                        >
                        <v-btn class="accept" text @click="closeDialog"
                            >Sim</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <Loader :hasReady="hasReady" />
        <CreateModule :show="true" />
        <CreateLesson :show="true" />

        <!-- Diálogo Novo Módulo -->
        <v-dialog
            v-model="newModuleDialog"
            class="new-module-dialog"
            :max-width="480"
        >
            <v-card class="modal-card">
                <v-card-title class="new-module-title"
                    >Criar Novo Módulo</v-card-title
                >
                <v-card-text>
                    <v-text-field
                        v-model="newModuleTitle"
                        label="Título do Módulo"
                        required
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="new-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="newModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="createNewModule"
                        :disabled="newModuleTitle.length === 0"
                        >Criar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo Editar Módulo -->
        <v-dialog
            v-model="editModuleDialog"
            class="edit-module-dialog"
            :max-width="480"
        >
            <v-card class="modal-card">
                <v-card-title class="edit-module-title"
                    >Editar Módulo</v-card-title
                >
                <v-card-text>
                    <v-text-field
                        v-model="editModuleTitle"
                        label="Título do Módulo"
                        required
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="edit-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="editModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        @click="updateModule"
                        :disabled="editModuleTitle.length === 0"
                        >Salvar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo Excluir Módulo/Aula -->
        <v-dialog v-model="deleteModuleDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">Excluir Módulo</h3>
                </v-card-title>
                <v-card-subtitle>
                    <p class="mb-0">
                        Tem certeza que deseja excluir este módulo? Esta ação
                        não poderá ser desfeita.
                    </p>
                </v-card-subtitle>
                <v-card-text>
                    <p>
                        Título:
                        <strong>{{ selectedLessonDelete.title }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions class="edit-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="deleteModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        @click="deleteLesson"
                        >Excluir</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <v-dialog
        v-model="dialogMatricularAluno"
        transition="dialog-bottom-transition"
        :max-width="600"
        id="dialogMatricularAluno"
    >
        <v-card class="modal-card">
            <v-card-title>
                <h3>Matricular Aluno</h3>
            </v-card-title>
            <v-card-text>
                <p>Selecione um aluno para realizar a matrícula:</p>

                <v-autocomplete
                    v-model="alunoSelecionado"
                    :items="listaAlunos"
                    item-title="name"
                    item-value="id"
                    label="Aluno"
                    variant="outlined"
                    density="compact"
                    :disabled="loadingMatricula || showNewUserForm"
                    :loading="loadingAlunos"
                    return-object
                    required
                    :no-data-text="'Nenhum aluno encontrado'"
                />

                <div class="new-user-btn-container">
                    <v-btn
                        variant="outlined"
                        color="primary"
                        @click="toggleNewUserForm"
                        :disabled="loadingMatricula"
                        class="new-user-btn"
                        :icon="$vuetify.display.xs"
                        size="small"
                    >
                        <v-icon>mdi-account-plus</v-icon>
                        <span v-if="!$vuetify.display.xs" class="ml-2">Novo Aluno</span>
                    </v-btn>
                </div>

                <!-- Formulário para novo usuário -->
                <v-expand-transition>
                    <div v-if="showNewUserForm" class="new-user-form mt-4">
                        <v-divider class="mb-4"></v-divider>
                        <h4 class="mb-3">Cadastrar Novo Aluno</h4>
                        
                        <v-form ref="newUserForm" v-model="newUserFormValid">
                            <v-text-field
                                v-model="newUser.name"
                                label="Nome completo"
                                variant="outlined"
                                density="compact"
                                :rules="nameRules"
                                :disabled="loadingMatricula"
                                required
                            ></v-text-field>

                            <v-text-field
                                v-model="newUser.email"
                                label="E-mail"
                                type="email"
                                variant="outlined"
                                density="compact"
                                :rules="emailRules"
                                :disabled="loadingMatricula"
                                required
                            ></v-text-field>

                            <v-text-field
                                v-model="newUser.cpf"
                                label="CPF"
                                variant="outlined"
                                density="compact"
                                :rules="cpfRules"
                                :disabled="loadingMatricula"
                                v-mask="'###.###.###-##'"
                                required
                            ></v-text-field>
                        </v-form>
                    </div>
                </v-expand-transition>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="flex-grow-1 cancel-btn"
                    color="grey-darken-4"
                    variant="tonal"
                    text="Cancelar"
                    @click="closeMatriculaDialog"
                    :disabled="loadingMatricula"
                    id="btnCancelarMatricula"
                ></v-btn>
                <v-btn
                    v-if="!showNewUserForm"
                    class="flex-grow-1"
                    color="primary"
                    variant="flat"
                    text="Matricular"
                    @click="manualEnrol"
                    :loading="loadingMatricula"
                    :disabled="!alunoSelecionado || loadingMatricula"
                ></v-btn>
                <v-btn
                    v-else
                    class="flex-grow-1"
                    color="success"
                    variant="flat"
                    text="Criar e Matricular"
                    @click="createUserAndEnrol"
                    :loading="loadingMatricula"
                    :disabled="!newUserFormValid || loadingMatricula"
                ></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Sesson from '@/utils/Weflix/sesson';
    import Loader from '@/components/Weflix/Loader.vue';
    import ApiModules from '@/utils/modules';
    import ApiLesson from '@/utils/lesson';
    import Courses from '@/utils/courses';
    import { mapState, mapActions } from 'vuex';
    import draggable from 'vuedraggable';
    import { toast } from 'vue3-toastify';
    import clickOutside from '@/directives/click-outside';
    import ApiUser from '@/utils/user';

    export default {
        directives: {
            clickOutside,
        },
        components: {
            Loader,
            draggable,
        },
        data() {
            return {
                seasson: [],
                valueProgressTemporary: 0,
                deleteItem: false,
                nameItem: '',
                season: '',
                seasonSelected: null,
                modules: [],
                hasReady: false,
                descriptionCollection: '',
                nameCollection: '',
                totalVideos: 0,
                totalMinutes: 0,
                totalViews: 0,
                dataViewVideos: [],
                manySeason: false,
                dragging: false,
                draggingLesson: false,
                allModulesOpen: true,
                searchTerm: '',
                infoCount: [],
                newModuleDialog: false,
                newModuleTitle: '',
                newModuleDescription: '',
                editModuleDialog: false,
                editModuleTitle: '',
                currentModuleId: null,
                deleteModuleDialog: false,
                selectedLessonDelete: { id: null, title: '' },
                dialogMatricularAluno: false,
                alunoSelecionado: null,
                listaAlunos: [],
                loadingMatricula: false,
                loadingAlunos: false,
                showNewUserForm: false,
                newUserFormValid: false,
                newUser: {
                    name: '',
                    email: '',
                    cpf: ''
                },
                nameRules: [
                    v => !!v || 'Nome é obrigatório',
                    v => (v && v.length >= 2) || 'Nome deve ter pelo menos 2 caracteres'
                ],
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'
                ],
                cpfRules: [
                    v => !!v || 'CPF é obrigatório',
                    v => this.validateCPF(v) || 'CPF deve ser válido'
                ],
            };
        },
        mounted() {
            const toastMessage = this.$route.query.toast;
            const toastType = this.$route.query.type || 'success';

            if (toastMessage) {
                this.notify(toastMessage, toastType);

                setTimeout(() => {
                    const newQuery = { ...this.$route.query };
                    delete newQuery.toast;
                    delete newQuery.type;
                    this.$router.replace({ query: newQuery });
                }, 3000);
            }
            this.getUserData();
        },
        computed: {
            ...mapState(['token', 'currentCollections', 'currentModule']),
            filteredModules() {
                if (!this.searchTerm) return this.modules;
                const searchLower = this.searchTerm.toLowerCase();
                return this.modules.filter((module) =>
                    module.title.toLowerCase().includes(searchLower)
                );
            },
        },
        methods: {
            ...mapActions(['storeCurrentModule']),

            editarCurso() {
                this.$router.push(
                    `/dashboard/form-curso/${this.currentCollections.id}`
                );
            },
            async manualEnrol() {
                const payload = {
                    tokenStudent: this.alunoSelecionado.id,
                    tokenCourse: this.currentCollections.id,
                };
                try {
                    const response = await Courses.manualEnrol(
                        this.token,
                        payload
                    );
                    this.notify(
                        `Aluno ${this.alunoSelecionado.name} matriculado com sucesso`,
                        'success'
                    );
                    this.dialogMatricularAluno = false;
                    this.alunoSelecionado = null;
                    this.getModules();
                } catch (err) {
                    this.notify(
                        'Erro ao matricular aluno. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao matricular aluno:', err);
                }
            },
            storeCurrentModuleLocal(item) {
                this.storeCurrentModule({ currentModule: item });
            },

            openModalDelete(item) {
                this.deleteModuleDialog = true;
                this.selectedLessonDelete = item;
            },

            openNewModuleDialog() {
                this.newModuleDialog = true;
            },

            async createNewModule() {
                const payload = {
                    idCourse: this.currentCollections.id,
                    title: this.newModuleTitle,
                    sample: 0,
                };
                try {
                    await ApiModules.createNewModule(payload, this.token);
                    await this.getModules();
                    this.newModuleDialog = false;
                    this.newModuleTitle = '';
                    this.newModuleDescription = '';
                } catch (error) {
                    this.notify(
                        'Erro ao criar novo módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao criar novo módulo:', error);
                }
            },

            toggleAllModules() {
                this.allModulesOpen = !this.allModulesOpen;
                this.modules.forEach((module) => {
                    module.isOpen = this.allModulesOpen;
                });
            },

            toggleDropdown(element) {
                const isOpen = element.showDropdown;
                // Fecha todos os dropdowns
                this.modules.forEach((m) => (m.showDropdown = false));
                // Se não estava aberto, abre o clicado
                if (!isOpen) {
                    element.showDropdown = true;
                }
            },

            getLessonIcon(type) {
                const icons = {
                    1: 'fa-solid fa-video',
                    2: 'fa-solid fa-video',
                    3: 'fa-solid fa-video',
                    4: 'fa-solid fa-file-pdf',
                    5: 'fa-solid fa-list-check',
                };
                return icons[type];
            },

            deleteVideo(id, name) {
                this.deleteItem = true;
                this.nameItem = name;
            },

            closeDialog() {
                this.deleteItem = false;
            },

            editVideo(id) {
                this.$router.push('/admin/video/' + id);
            },
            openDialogMatricularAluno() {
                this.dialogMatricularAluno = true;
                this.showNewUserForm = false;
                this.resetNewUserForm();
            },
            toggleNewUserForm() {
                this.showNewUserForm = !this.showNewUserForm;
                if (!this.showNewUserForm) {
                    this.resetNewUserForm();
                }
            },
            resetNewUserForm() {
                this.newUser = {
                    name: '',
                    email: '',
                    cpf: ''
                };
                this.newUserFormValid = false;
                this.alunoSelecionado = null;
            },
            closeMatriculaDialog() {
                this.dialogMatricularAluno = false;
                this.showNewUserForm = false;
                this.resetNewUserForm();
            },
            validateCPF(cpf) {
                if (!cpf) return false;
                // Remove caracteres não numéricos
                cpf = cpf.replace(/[^\d]/g, '');
                
                // Verifica se tem 11 dígitos
                if (cpf.length !== 11) return false;
                
                // Verifica se todos os dígitos são iguais
                if (/^(\d)\1{10}$/.test(cpf)) return false;
                
                // Validação do CPF
                let sum = 0;
                for (let i = 0; i < 9; i++) {
                    sum += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let remainder = 11 - (sum % 11);
                if (remainder === 10 || remainder === 11) remainder = 0;
                if (remainder !== parseInt(cpf.charAt(9))) return false;
                
                sum = 0;
                for (let i = 0; i < 10; i++) {
                    sum += parseInt(cpf.charAt(i)) * (11 - i);
                }
                remainder = 11 - (sum % 11);
                if (remainder === 10 || remainder === 11) remainder = 0;
                if (remainder !== parseInt(cpf.charAt(10))) return false;
                
                return true;
            },
            async createUserAndEnrol() {
                if (!this.newUserFormValid) {
                    this.notify('Por favor, preencha todos os campos corretamente.', 'error');
                    return;
                }

                this.loadingMatricula = true;
                
                try {
                    // Primeiro, criar o usuário usando a API
                    const userPayload = {
                        address: "",
                        addressComplement: "",
                        addressNumber: "",
                        birthdate: "",
                        city: "",
                        country: "br",
                        county: "AC",
                        email: this.newUser.email,
                        gender: "",
                        idNumber: "",
                        name: this.newUser.name,
                        neighborhood: "",
                        phone: "",
                        photo: "",
                        postcode: "",
                        socialNumber: this.newUser.cpf.replace(/[^\d]/g, ''), // Remove formatação
                        status: 1,
                        type: 3
                    };

                    console.log('Criando usuário com payload:', userPayload);
                    const userResponse = await ApiUser.CreateUser(this.token, userPayload);
                    console.log('Resposta da criação do usuário:', userResponse);
                    
                    if (userResponse && userResponse.id) {
                        // Aguardar um momento para garantir que o usuário foi criado
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        
                        // Depois, matricular o usuário no curso usando o ID retornado
                        const enrolPayload = {
                            tokenStudent: userResponse.id,
                            tokenCourse: this.currentCollections.id,
                        };

                        console.log('Matriculando usuário com payload:', enrolPayload);
                        const enrolResponse = await Courses.manualEnrol(this.token, enrolPayload);
                        console.log('Resposta da matrícula:', enrolResponse);
                        
                        this.notify(
                            `Usuário ${this.newUser.name} criado e matriculado com sucesso!`,
                            'success'
                        );
                        
                        // Fechar diálogo e atualizar dados
                        this.closeMatriculaDialog();
                        
                        // Atualizar lista de alunos e estatísticas
                        await this.getUserData();
                        await this.getModules();
                        await this.getStatusCourse();
                        
                    } else {
                        throw new Error('Erro ao criar usuário: resposta inválida da API');
                    }
                } catch (err) {
                    console.error('Erro ao criar usuário e matricular:', err);
                    
                    let errorMessage = 'Erro ao criar usuário e matricular. Por favor, tente novamente.';
                    
                    if (err.response && err.response.data) {
                        errorMessage = err.response.data.message || errorMessage;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    
                    this.notify(errorMessage, 'error');
                } finally {
                    this.loadingMatricula = false;
                }
            },
            async getSesson() {
                const param = this.$route.params.slug;
                try {
                    const response = await Sesson.getSessonByCollection(
                        this.token,
                        param
                    );
                    if (response.length > 0) {
                        this.season = response;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    } else {
                        await this.newSeason();
                        const newResponse = await Sesson.getSessonByCollection(
                            this.token,
                            param
                        );
                        this.season = newResponse;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    }
                } catch (error) {
                    this.notify(
                        'Erro ao obter dados da coleção. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao obter dados da coleção:', error);
                }
            },

            async getModules() {
                try {
                    const response =
                        await ApiModules.getDataModulesAndLessonsByCourse(
                            this.currentCollections.id,
                            this.token
                        );
                    this.modules = response
                        .sort((a, b) => a.order - b.order)
                        .map((module, index) => ({
                            ...module,
                            isOpen: index === 0,
                            showDropdown: false,
                        }));
                    this.hasReady = true;
                } catch (error) {
                    this.notify(
                        'Erro ao processar os módulos. Por favor, tente novamente.',
                        'error'
                    );
                    console.error(error);
                }
            },

            changeSeason() {
                this.hasReady = false;
                this.getVideos(this.seasonSelected);
            },

            async getCourseTypeCount() {
                try {
                    const response = await Courses.getCourseTypeCount(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao obter contadores do curso:', error);
                }
            },

            async onDragEnd() {
                const payload = this.modules.map((module, index) => ({
                    id: module.id,
                    order: index + 1,
                }));
                try {
                    await ApiModules.orderModules(this.token, payload);
                } catch (error) {
                    console.error('Erro ao alterar ordem dos módulos:', error);
                }
            },

            async onDragEndLesson(moduleId) {
                const module = this.modules.find((m) => m.id === moduleId);
                if (!module) return;
                const payload = module.lessons.map((lesson, index) => ({
                    id: lesson.id,
                    order: index + 1,
                }));
                try {
                    await ApiModules.orderLessons(this.token, payload);
                } catch (error) {
                    console.error('Erro ao alterar ordem das lições:', error);
                }
            },

            async getStatusCourse() {
                try {
                    const response = await ApiModules.getStatusCourse(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao pegar status do curso:', error);
                }
            },

            openModalEdit(lesson) {
                if (lesson.type == 5) {
                    this.$router.push(`/dashboard/quiz/${lesson.id}`);
                } else if ([1, 2, 3].includes(lesson.type)) {
                    this.$router.push(`/dashboard/editar-video/${lesson.id}`);
                } else if (lesson.type == 4) {
                    this.$router.push(`/dashboard/editar-arquivo/${lesson.id}`);
                }
            },

            openModalEditModule(moduleId, moduleTitle) {
                this.currentModuleId = moduleId;
                this.editModuleTitle = moduleTitle;
                this.editModuleDialog = true;
            },

            async updateModule() {
                try {
                    const payload = {
                        idCourse: this.currentCollections.id,
                        title: this.editModuleTitle,
                        sample: 0,
                    };
                    await ApiModules.editModule(
                        payload,
                        this.token,
                        this.currentModuleId
                    );
                    await this.getModules();
                    this.editModuleDialog = false;
                    this.notify('Módulo atualizado com sucesso.', 'success');
                } catch (error) {
                    this.notify(
                        'Erro ao atualizar módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao atualizar módulo:', error);
                }
            },

            confirmDeleteModule() {
                this.deleteModuleDialog = true;
            },

            async deleteModule() {
                try {
                    await ApiModules.deleteModule(
                        this.token,
                        this.currentModuleId
                    );
                    await this.getModules();
                    this.deleteModuleDialog = false;
                    this.editModuleDialog = false;
                    this.notify('Módulo excluído com sucesso.', 'success');
                } catch (error) {
                    this.notify(
                        'Erro ao excluir módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao excluir módulo:', error);
                }
            },

            async deleteLesson() {
                try {
                    await ApiLesson.deleteLesson(
                        this.selectedLessonDelete.id,
                        this.token
                    );
                    await this.getModules();
                    this.deleteModuleDialog = false;
                    this.editModuleDialog = false;
                    toast.success('Lição excluída com sucesso!');
                } catch (error) {
                    toast.error(
                        'Erro ao excluir lição: ',
                        error?.message
                            ? error.message
                            : 'Por favor, tente novamente.'
                    );
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
            goToMatriculasReport() {
                // Navega para a aba de relatórios com filtros de matrículas e nome do curso
                this.$router.push({
                    path: '/dashboard/relatorios',
                    query: {
                        filter: 'matriculas',
                        courseName: this.currentCollections.comercialName
                    }
                });
            },
            async getUserData() {
                try {
                    const response = await ApiUser.getAllUser(this.token);
                    this.listaAlunos = response.content
                        .filter(
                            (user) => user.status == 1 && user.name && user.id
                        )
                        .map((user) => ({
                            name: user.name,
                            id: user.id,
                        }));
                } catch (err) {
                    this.notify(
                        'Erro ao carregar dados do Usuário. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao carregar dados do Usuário');
                }
            },
        },
        created() {
            this.getModules();
            this.getStatusCourse();
        },
    };
</script>

<style scoped>
    @import url(./global.css);
    @import url('@/css/weeduc/admin/course.css');
    button.newEnrol {
        border: 2px solid #250891;
        padding: 3px 10px;
        border-radius: 5px;
        margin-left: 10px;
        transition: all 0.5s ease;
    }
    .dark button.newEnrol {
        border: 2px solid #ffffff;
        padding: 3px 10px;
        border-radius: 5px;
        margin-left: 10px;
        transition: all 0.5s ease;
    }
    button.newEnrol:hover {
        border: 2px solid #250891;
        background-color: #250891;
        color: #fff;
    }
    button.newEnrol svg {
        width: 20px;
        height: 20px;
        fill: #250891;
    }
    .dark button.newEnrol svg {
        width: 20px;
        height: 20px;
        fill: #ffffff;
    }
    button.newEnrol:hover svg {
        fill: #fff;
    }
    .no-uppercase :deep(.v-btn__content) {
        text-transform: none;
    }
    
    .clickable-stats {
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 8px;
        padding: 8px;
    }
    
    .clickable-stats:hover {
        background-color: rgba(37, 8, 145, 0.1);
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(37, 8, 145, 0.2);
    }
    
    .dark .clickable-stats:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
</style>
